export default __webpack_public_path__ + "static/media/Comp 2_00033.ab526311.png";